import { render, staticRenderFns } from "./component-f39478b9.vue?vue&type=template&id=0422e1d6&scoped=true&"
import script from "./component-f39478b9.vue?vue&type=script&lang=js&"
export * from "./component-f39478b9.vue?vue&type=script&lang=js&"
import style0 from "./component-f39478b9.vue?vue&type=style&index=0&id=0422e1d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0422e1d6",
  null
  
)

export default component.exports